import { render, staticRenderFns } from "./CommissionTypeColumn.vue?vue&type=template&id=2d469900&scoped=true&"
import script from "./CommissionTypeColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionTypeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d469900",
  null
  
)

export default component.exports